import ACTIONS from "../../constants/actions";
import Xhr from "../../helpers/Xhr";

export const getResultLive = () => dispatch => {
	Xhr.resultLive().then((resp) => {
		dispatch({
			type: ACTIONS.RESULT.GET_LIVE,
			data: resp ? resp.data : [],
		})
	});
};

export const getResultLine = (date) => dispatch => {
	dispatch({type: ACTIONS.RESULT.FETCHING_LINE});

	Xhr.resultLine(date).then((resp) => {
		dispatch({
			type: ACTIONS.RESULT.GET_LINE,
			data: resp ? resp.data : [],
		})
	});
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/result.js